<template>
  <div class="upload-file">
    <el-upload ref="fileUpload" :disabled="disabled" multiple :action="uploadFileUrl" :before-upload="handleBeforeUpload" :file-list="fileList" :limit="limit" :on-error="handleUploadError" :on-exceed="handleExceed" :on-success="handleUploadSuccess" :show-file-list="false" :headers="headers" class="upload-file-uploader upload-area">
      <!-- 上传按钮 -->
      <el-button size="mini" :disabled="disabled" type="primary">选取文件</el-button>
      <!-- 上传提示 -->
      <div v-if="showTip" slot="tip" class="el-upload__tip">
        <template v-if="fileSize">
          上传文件大小不超过 <b style="color: #f56c6c">{{ fileSize }}MB</b>
        </template>
      </div>
    </el-upload>

    <!-- 文件列表 -->
    <transition-group class="upload-file-list el-upload-list el-upload-list--text" name="el-fade-in-linear" tag="ul">
      <li v-for="(file, index) in fileList" :key="file.filePath" class="el-upload-list__item ele-upload-list__item-content">
        <el-link :href="`${baseUrl}${file.filePath}`" :underline="false" target="_blank">
          <span class="el-icon-document"> {{ file.name }} </span>
        </el-link>
        <div v-if="showDelect" class="ele-upload-list__item-content-action">
          <el-link :underline="false" type="danger" @click="handleDelete(index)">删除</el-link>
        </div>
      </li>
    </transition-group>
  </div>
</template>

<script>
import { getToken } from '@/utils/auth'
import tool from '@/utils/tool.js'
import {
  getCommonList,
  saveCommon,
  delCommon,
} from '@/api/crm/order/salesOrder'
export default {
  name: 'UploadFile',
  props: {
    // 值
    value: [String, Object, Array],
    // 数量限制
    limit: {
      type: Number,
      default: 20
    },
    // 大小限制(MB)
    fileSize: {
      type: Number,
      default: 10
    },
    disabled: {
      type: Boolean,
      default: false
    },
    // 文件类型, 例如['png', 'jpg', 'jpeg']
    fileType: {
      type: Array,
      default: () => [
        'png',
        'jpg',
        'jpeg',
        'doc',
        'xls',
        'ppt',
        'txt',
        'pdf',
        'xlsx',
        'docx',
        'pptx'
      ]
    },
    // 是否显示提示
    isShowTip: {
      type: Boolean,
      default: true
    },
    showDelect: {
      type: Boolean,
      default: true
    },
    referenceId: {
      type: Number,
      default: 0
    },
    referenceTable: {
      type: String,
      default: '',
    },
    attribute1: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      number: 0,
      uploadList: [],
      baseUrl: process.env.VUE_APP_URL,
      uploadFileUrl: process.env.VUE_APP_FILE_UPLOAD_URL, // 上传文件服务器地址
      headers: {
        'eb-token': getToken()
      },
      fileList: [],
      successFileName: ''
    }
  },
  computed: {
    // 是否显示提示
    showTip() {
      return this.isShowTip && (this.fileType || this.fileSize)
    }
  },
  watch: {
    value: {
      handler(val) {
        if (this.referenceId) {
          this.getCommonListById();
        } else {
          this.fileList = []
          return []
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 上传前校检格式和大小
    handleBeforeUpload(file) {
      console.log(file)
      // 校检文件类型
      if (this.fileType) {
        const fileName = file.name.split('.')
        const fileExt = fileName[fileName.length - 1]
        const isTypeOk = this.fileType.indexOf(fileExt) >= 0
        if (!isTypeOk) {
          this.$message({
            type: 'error',
            message: `文件格式不正确, 请上传${this.fileType.join(
              '/'
            )}图片格式文件!`
          })
          return false
        }
      }
      // 校检文件大小
      if (this.fileSize) {
        const isLt = file.size / 1024 / 1024 < this.fileSize
        if (!isLt) {
          this.$message({
            type: 'error',
            message: `上传文件大小不能超过 ${this.fileSize} MB!`
          })
          return false
        }
      }
      this.successFileName = file.name
      this.number++
      if (file.size / 1024 / 1024 > 1) {
        return new Promise((resolve, reject) => {
          tool.compress(file,
            (newfileex) => {
              console.log('newFile', newfileex)
              resolve(newfileex)
            })
        })
      }
      return true
    },
    // 文件个数超出
    handleExceed() {
      this.$message({
        type: 'error',
        message: `上传文件数量不能超过 ${this.limit} 个!`
      })
    },
    // 上传失败
    handleUploadError(err) {
      this.$message({
        type: 'error',
        message: '上传文件失败，请重试'
      })
    },
    // 上传成功回调
    handleUploadSuccess(res, file) {
      console.log(res, file)
      if (res.code === 200) {
        // this.uploadList.push({
        //   name: this.successFileName,
        //   url: res.data.fileName
        // })
        // this.uploadedSuccessfully()
        this.saveCommonInfo(res.data.fileName)
      } else {
        this.number--
        this.$refs.fileUpload.handleRemove(file)
        this.uploadedSuccessfully()
      }
    },
    saveCommonInfo(fileUrl) {
       let saveInfo = {
        referenceTable: this.referenceTable,
        attribute1: this.attribute1,
        intReferenceId: this.referenceId,
        filePath: fileUrl,
      }
      saveCommon(saveInfo).then((response) => {
        if(response.code == 200) {
          this.getCommonListById();
        } else {
          this.$message.warning('上传失败！')
          return
        }
      })
    },
    getCommonListById() {
      let queryInfo = {
        referenceTable: this.referenceTable,
        attribute1: this.attribute1,
        intReferenceId: this.referenceId,
      }
      getCommonList(queryInfo).then((response) => {
        if(response.code == 200) {
          this.fileList = [];
          for(let i = 0; i < response.data.length; i++) {
            const item = {
              name: '附件' + (i + 1), 
              filePath: response.data[i].filePath,
              fileId: response.data[i].fileId,
              attribute1: response.data[i].attribute1,
              intReferenceId: response.data[i].intReferenceId,
            }
            this.fileList.push(item)
          }
        } else {
          this.fileList = []
          return []
        }
      })
    },
    // 删除文件
    handleDelete(index) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        delCommon(this.fileList[index].fileId).then((response) => {
          if(response.code == 200) {
            this.getCommonListById();
          } else {
            this.$message.warning('删除失败！')
          }
        })
      }).catch(() => {
        return;
      });
    },
    // 上传结束处理
    uploadedSuccessfully() {
      this.successFileName = ''
      if (this.number > 0 && this.uploadList.length === this.number) {
        this.fileList = this.fileList.concat(this.uploadList)
        console.log(this.fileList)
        this.uploadList = []
        this.number = 0
        // console.log(this.listToString(this.fileList), 1111111111111111)
        this.$emit('update:value', this.listToString(this.fileList))
      }
    },
    // 获取文件名称
    getFileName(name) {
      // if (name.lastIndexOf('/') > -1) {
      //   return name.slice(name.lastIndexOf('/') + 1)
      // } else {
      //   return ''
      // }
    },
    // 对象转成数组
    listToString(list) {
      const file = []
      for (const i in list) {
        file[i] = {}
        file[i].accessoryName = list[i].name
        file[i].accessoryUrl = list[i].url
      }
      return file
    }
    // // 对象转成指定字符串分隔
    // listToString(list, separator) {
    //   let strs = "";
    //   separator = separator || ",";
    //   for (let i in list) {
    //     strs += list[i].url + separator;
    //   }
    //   return strs != "" ? strs.substr(0, strs.length - 1) : "";
    // },
  }
}
</script>

<style scoped lang="scss">
.upload-area {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 5px;
}

.upload-file-uploader {
  margin-bottom: 5px;
}
.upload-file-list .el-upload-list__item {
  border: 1px solid #e4e7ed;
  line-height: 2;
  margin-bottom: 10px;
  position: relative;
}
.upload-file-list .ele-upload-list__item-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: inherit;
}
.ele-upload-list__item-content-action .el-link {
  margin-right: 10px;
}
</style>
